import CloseOutlinedIcon from './CloseOutlinedIcon'

export default CloseOutlinedIcon
